import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { ProductClick, TrackingModule } from '@app/+product/store';
import { Product } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-section',
  templateUrl: './product-section.component.html',
  styleUrls: ['./product-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSectionComponent {
  @Input()
  title: string;
  @Input()
  productList: Product[];
  @Input()
  seoContext: string[] = [];
  @Input()
  itemMax: number;
  @Input()
  isSlider: boolean;
  @Input()
  isCms: boolean;
  @Input()
  trackingTitle: string;

  @Output() productClick = new EventEmitter<ProductClick>();
  @Output() moduleScroll = new EventEmitter<TrackingModule>();
  @Output() moduleDisplay = new EventEmitter<TrackingModule>();

  onProductClick(event: ProductClick) {
    this.productClick.emit(event);
  }

  onModuleScroll(event: TrackingModule) {
    this.moduleScroll.emit(event);
  }

  onModuleDisplay(event: TrackingModule) {
    this.moduleDisplay.emit(event);
  }
}
